<template>
  <div id="cookies">
    <div class="content">
      <header>
        <div class="row-inner">
          <a href="/">
            <img class="logo logo-desktop" src="./../assets/img/logos/logo-driessen-desktop.svg" alt="Driessen Logo">
            <img class="logo logo-mobile" src="./../assets/img/logos/logo-driessen-mobile.svg" alt="Driessen Logo">
          </a>
        </div>
      </header>
      <main>
        <h1>Cookies</h1>
        <div class="row-inner content-style content-style--white">
          <p>Onze website maakt gebruik van cookies. Dit zijn kleine tekstbestandjes die bij een bezoek op de harde schijf van uw computer worden geplaatst. Een cookie bevat gegevens waarmee uw computer kan worden herkend, bijvoorbeeld bij herbezoek. Op deze wijze kunnen wij bijvoorbeeld onderdelen van onze website afstemmen op uw persoonlijke voorkeuren en het gebruiksgemak van onze website
            verbeteren.</p>
          <h3>Soorten cookies</h3>
          <p>Wij gebruiken 3 typen cookies:</p>
          <ol>
            <li><strong>Essentiële cookies</strong><br>
              Deze cookies zorgen ervoor dat deze website naar behoren functioneert. Ook houden we met deze cookies anoniem website statistieken bij.
            </li>
            <li><strong>Analytische cookies</strong><br>
              Deze cookies verzamelen informatie die wordt gebruikt om ons te helpen begrijpen hoe onze website wordt gebruikt of hoe effectief onze marketingcampagnes zijn. Ook helpen deze cookies ons om deze website aan te passen en zo de gebruikservaring te kunnen verbeteren.
            </li>
            <li><strong>Advertentie cookies</strong><br>
              Met deze cookies kan uw surfgedrag worden gemonitord door advertentienetwerken waardoor we advertenties kunnen tonen op basis van interesses en surfgedrag. Ook voeren deze cookies functies uit waarmee onder andere wordt voorkomen dat dezelfde advertentie voortdurend verschijnt.
            </li>
          </ol>
          <h3>Uw cookie instellingen wijzigen?</h3>
          <p>Wilt u uw huidige cookie instellingen wijzigen, <a class="csconsentlink" href="javascript:void(0)">klik dan hier</a>.</p>
          <h3>Privacy statements website-partners</h3>
          <p>Onze website-partners hanteren de volgende privacy statements:</p>
          <ul class="disc">
            <li><a href="http://www.hotjar.com/privacy" target="_blank" rel="noopener noreferrer">Privacybeleid HotJar</a></li>
            <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacybeleid Google (Analytics & DoubleClick)</a></li>
            <li><a href="https://www.facebook.com/about/privacy/" target="_blank" rel="noopener noreferrer">Privacybeleid Facebook</a></li>
            <li><a href="https://privacy.linkedin.com" target="_blank" rel="noopener noreferrer">Privacybeleid LinkedIn</a></li>
          </ul>
          <h3>Liever helemaal geen cookies?</h3>
          <p>U kunt er voor kiezen om in uw browser cookies (altijd) buiten werking te stellen. Raadpleeg hiervoor de helpfunctie van uw browser. Dit kan echter wel als gevolg hebben dat bepaalde onderdelen van onze website niet of minder goed toegankelijk voor u zijn.</p>
        </div>
      </main>
      <footer>
        <div class="row-inner">
          <div class="footer-content">
            <div class="logo-footer">
              <img class="logo-drop" src="./../assets/img/logos/logo-driessen-drop.svg" alt="Driessen Logo">
            </div>
            <div class="social-links follow">
              <span class="label">Volg ons</span>
              <ul>
                <li class="facebook">
                  <a href="https://www.facebook.com/driessen.nl" target="_blank" rel="noopener noreferrer">Facebook</a>
                </li>
                <li class="linkedin">
                  <a href="https://www.linkedin.com/company/driessen-nl" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                </li>
                <li class="twitter">
                  <a href="https://twitter.com/Driessen_nl"
                     target="_blank" rel="noopener noreferrer">Twitter</a>
                </li>
                <li class="youtube">
                  <a href="https://www.youtube.com/user/DriessenHRM"
                     target="_blank" rel="noopener noreferrer">Whatsapp</a>
                </li>
                <li class="instagram">
                  <a href="https://www.instagram.com/driessen.nl"
                     target="_blank" rel="noopener noreferrer">Instagram</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Cookies',
    data() {
      return {}
    },
    methods: {
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    mounted() {
      this.toggleBodyClass('addClass', 'cookies');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'cookies');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Cookies.vue